import { useLocation } from 'react-router-dom-v5-compat';
import { useMediaQuery } from '@material-ui/core';

import { APP_LOGO_VARIANT, AppLogo } from 'src/components/AppLogo';
import { AuthenticationBanner } from 'src/components/AuthenticationBanner';
import { AuthTypeSeparator } from 'src/components/AuthTypeSeparator';
import OAuthPanel from 'src/components/OAuthPanel';
import PageLayout from 'src/components/PageLayout';
import SignUpAgreement from 'src/components/SignUpAgreement';
import { UnauthenticatedPageContentLayout } from 'src/components/UnauthenticatedPageContentLayout';
import { UnauthenticatedPageFooterTextLink } from 'src/components/UnauthenticatedPageFooterTextLink';
import { ROUTES } from 'src/routes';

import { RegistrationForm } from './components/RegistrationForm';
import { useStyles } from './useStyles';
import { useViewModel } from './useViewModel';

export const SignUpPage = () => {
  const styles = useStyles();

  const location = useLocation();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const {
    loading,
    submitting,
    registerError,
    handleFormChange,
    handleRegister,
    handleOAuthStart,
    handleOAuthSuccess,
    handleOAuthError,
  } = useViewModel();

  return (
    <PageLayout
      className={styles.root}
      data-testid="SignUpPage"
    >
      <div className={styles.layout}>
        <div className={styles.wrapper}>
          <UnauthenticatedPageContentLayout
            title="Welcome to Anyword"
            subtitle={`We recommend signing up with your work email\nto keep all your marketing content in one place`}
          >
            <AppLogo
              className={styles.logo}
              variant={APP_LOGO_VARIANT.black}
            />

            <OAuthPanel
              label="Start with Google"
              loading={loading}
              disabled={submitting}
              onStart={handleOAuthStart}
              onSuccess={handleOAuthSuccess}
              onError={handleOAuthError}
            />

            <AuthTypeSeparator
              className={styles.oauthLabel}
              label="Or continue with work email"
            />

            <RegistrationForm
              classes={{
                root: styles.form,
              }}
              loading={loading || submitting}
              error={registerError}
              onChange={handleFormChange}
              onRegister={handleRegister}
            />

            <UnauthenticatedPageFooterTextLink
              text="Already have an account?"
              link={{
                to: ROUTES.SIGN_IN,
                testId: 'SignUpPageSignInLink',
                text: 'Log in',
              }}
              from={location?.state?.from}
            />
            <SignUpAgreement
              className={styles.agreement}
              showContactUs={true}
            />
          </UnauthenticatedPageContentLayout>
        </div>

        {!isMobile && <AuthenticationBanner className={styles.rightPanel} />}
      </div>
    </PageLayout>
  );
};
